export const gURIs = ['/gset', '/gaudit', '/gsearch', '/gaggregate', '/gworkflowTransition'];
